import React, { FC } from 'react'
import { voucherSumClickGtm } from '@shared/lib/gtm'
import { OldButton } from '@shared/ui/atoms/OldButton'
import { Payee } from '@root/api/ump-catalog-manager'

interface Props {
  denominationInfo: Payee
  handleDenominationClick: (denomination: Payee) => void
  activeDenomination: Payee
  activeService: Payee
}

const VoucherButton: FC<Props> = ({ denominationInfo, handleDenominationClick, activeDenomination, activeService }) => {
  const handleClickGTM = () => {
    handleDenominationClick(denominationInfo)
    voucherSumClickGtm(activeService?.providerName, denominationInfo.features?.buttonLabel as string)
  }

  return (
    <OldButton
      title={`${denominationInfo.features?.buttonLabel}`}
      isActive={activeDenomination?.serviceId === denominationInfo.serviceId}
      onClick={handleClickGTM}
      // icon={denominationInfo?.features?.buttonIcon}
    />
  )
}

export default VoucherButton
